module.exports = __webpack_public_path__ + "e785ad96ae2b21b141841376f2efdccd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/static/business_highlights.svg
// module id = 5096
// module chunks = 25